import { useEffect, useState } from 'react';
import { getInstallPrompt, promptInstall } from '../pwa.js';

/**
 * Hook per gestire l'installazione PWA.
 * Restituisce { canInstall, install }
 *   - canInstall: true quando il browser offre il prompt (beforeinstallprompt catturato)
 *   - install(): funzione da chiamare nel click handler (mostra prompt nativo)
 */
export function usePwaInstall() {
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    const prompt = getInstallPrompt();
    setCanInstall(!!prompt);

    const onAvailable = (e) => setCanInstall(e.detail.available);
    window.addEventListener('pwa:installable', onAvailable);
    return () => window.removeEventListener('pwa:installable', onAvailable);
  }, []);

  return { canInstall, install: promptInstall };
}